module.exports = __webpack_public_path__ + "images/9f0344529e37943f030671d86583ecec-MSW_LineArt_PanelSwap_SimonXT_To_IQ5_Slide5.png";